import React from 'react'
import { useCommonServices } from '../../lib/hooks'
import { capitalize } from '../../lib/utils/strings'

export const BrowserName: React.FC = () => <>{useCommonServices().browserService.browserDisplayName}</>

export const DesktopOperatingSystemName: React.FC = () => (
  <>{capitalize(useCommonServices().browserService.operatingSystemDisplayName)}</>
)
